import React from 'react';
import * as Joi from 'joi-browser';
import { Link } from 'react-router';
import { I18n } from 'react-redux-i18n-lite';

import PropTypes from 'prop-types';

import Logo from '../common/Logo';
import CustomButton from '../common/CustomButton';
import { getSkinFromStorageOrDefault } from '../../shared';
import { ROUTES } from '../../const';

const ERROR_INPUT_CLASSNAME = 'error-input';

class RegisterSSOCodeSelection extends React.Component {
  constructor(props) {
    super(props);
    this.onRegister = this.onRegister.bind(this);
    this.formSchema = Joi.object().keys({
      accessToken: Joi.string().required(),
      institutionCode: Joi.string().required(),
      classCode: Joi.string(),
      email: Joi.string().required(),
      name: Joi.string().required(),
      surname: Joi.string().required(),
      picture: Joi.string().required(),
      language: Joi.string()
    });

    this.state = {
      formError: ''
    };
  }

  static propTypes = {
    user: PropTypes.object,
    title: PropTypes.string,
    onSubmit: PropTypes.func
  };

  onRegister(e) {
    e.preventDefault();
    const { user } = this.props;
    const { schoolCode, classCode } = this.refs;

    user.institutionCode = schoolCode.value;
    if (classCode.value) user.classCode = classCode.value;

    const userOnlyFieldsNeed = {
      accessToken: user.accessToken,
      institutionCode: user.institutionCode,
      classCode: user.classCode,
      email: user.email,
      name: user.name,
      surname: user.surname,
      picture: user.picture,
      language: user.language
    };
    if (this.validateForm(userOnlyFieldsNeed)) {
      this.props.onSubmit(userOnlyFieldsNeed);
    }
  }

  validateForm(user) {
    let { schoolCode } = this.refs;

    schoolCode.className = !user.institutionCode ? ERROR_INPUT_CLASSNAME : '';
    const { error } = Joi.validate(user, this.formSchema);
    const missingRequiredFields = !!error;

    if (missingRequiredFields) {
      this.setState({
        formError: I18n.t('register.fieldRequiredError')
      });
      return false;
    }

    this.setState({ formError: '' });
    return true;
  }

  formErrorHandler() {
    const { formError } = this.state;
    return (
      <div className="error expand large-12 small-12 column text-center">
        <span>{formError}</span>
      </div>
    );
  }

  renderForm() {
    const theme = getSkinFromStorageOrDefault();
    const colors = theme.colors;

    return (
      <div>
        {this.formErrorHandler()}
        <form className="column small-12" onSubmit={this.onRegister}>
          <div className="column xlarge-offset-2 xlarge-8 large-offset-3 large-6 medium-offset-2 medium-8 small-12 text-center">
            <input id="schoolCode" type="text" ref="schoolCode" placeholder={I18n.t('register.schoolCode')} />
            <input
              id="classCode"
              type="text"
              ref="classCode"
              placeholder={`${I18n.t('register.classCode')} ${I18n.t('common.optional')}`}
            />
            <CustomButton
              color={colors.btnSuccess}
              colorHover={colors.btnSuccessHover}
              id="register-button"
              className="secondary button expanded select-buttons"
              value={I18n.t('common.go')}
            />
          </div>
        </form>
      </div>
    );
  }

  render() {
    const { user, title } = this.props;

    return (
      <div className="column xlarge-6 large-8 medium-10 small-12 content align-center">
        <div
          className="row box background-color-opaque background-color-opaque-opacity align-center"
          id="wrapperBackground"
        >
          <div className="row small-12 align-top">
            <div className="column">
              <div className="column small-12 text-center">
                <Logo customCss="logo-opaque" />
              </div>
              <h4 className="columns medium-12 text-center hide-for-small-only">{title}</h4>
              <h4 className="columns smallTitle text-center show-for-small-only">{title}</h4>
              <div className="column small-12 text-center">
                <img className="profile-image text-center" src={user.picture} alt="presentation" />
              </div>

              <div className="large-12 small-12 columns text-center profile-name">
                {user.name} {user.surname}
              </div>
              {this.renderForm()}
            </div>
          </div>

          <div className="row align-self-bottom text-center custom-text-center">
            <Link to={ROUTES.LOGIN}>
              <p className="text-margin-36 large-12 small-12 columns text-center bottom-link">
                {I18n.t('login.logout')}
              </p>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default RegisterSSOCodeSelection;
